import React from 'react';
import { Link } from 'react-router-dom'
import Bg from '../../../images/backgrounds/bg_image_2.webp'
import Bg3 from '../../../images/shapes/shape_title_under_line.svg'
import about1 from '../../../images/about/about_image_1.PNG'


const Start = (props) => {

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  }

  return (
    <section className="about_and_case_section section_space section_decoration bg-dark" style={{ backgroundImage: `url(${Bg})` }}>
      <div className="container">
        <div className="row align-items-center justify-content-lg-between">
          <div className="col-lg-6 order-lg-last d-none d-lg-block">
            <div className="about_image_2">
              <div className="image_wrap">
                <img src={about1} alt="Praeventor - Over Ons" />
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="about_content">
              <div className="heading_block mb-0 text-white">
                <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg3})` }}>
                  De start van onze reis
                </div>
                <h2 className="heading_text">
                  Ontstaan van <mark>Praeventor</mark>
                </h2>
                <p className="heading_description mb-0">
                  Welkom! Wij bouwen aan iets bijzonders, en jij bent hier precies op het juiste moment om ons te zien groeien. Ons verhaal is nog maar net begonnen, maar het is gebaseerd op pure passie en een sterk geloof in wat cybersecurity kan betekenen.
                </p>
                <div style={{ paddingTop: "40px"}}>
                  <Link onClick={ClickHandler} className="btn btn-primary" to="/contact">
                    <span className="btn_label" data-text="ONTDEK MEER">ONTDEK MEER</span>
                    <span className="btn_icon">
                      <i className="fa-solid fa-arrow-up-right"></i>
                    </span>
                  </Link>
                </div>

              </div>
            </div>
          </div>
        </div>

        {/*<div className="pt-170">*/}
          {/*<div className="heading_block text-center text-white">*/}
          {/*  <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Bg3})` }}>*/}
          {/*    Case Studies*/}
          {/*  </div>*/}
          {/*  <h2 className="heading_text mb-0">*/}
          {/*    Our latest <mark>Case</mark> Studies*/}
          {/*  </h2>*/}
          {/*</div>*/}

          {/*<div className="case_studies_wrapper">*/}
          {/*  {Project.slice(6, 9).map((project, prj) => (*/}
          {/*    <div className="case_study_block" key={prj}>*/}
          {/*      <div className="case_study_image">*/}
          {/*        <img src={project.pImg} alt="Techco - Cases" />*/}
          {/*      </div>*/}
          {/*      <div className="case_study_content">*/}
          {/*        <ul className="category_list unordered_list text-uppercase">*/}
          {/*          <li><a href="portfolio.html">{project.sub}</a></li>*/}
          {/*        </ul>*/}
          {/*        <h3 className="case_title">*/}
          {/*          <Link onClick={ClickHandler} to={`/portfolio_details/${project.slug}`}>{project.title}</Link>*/}
          {/*        </h3>*/}
          {/*        <p>*/}
          {/*          {project.description}*/}
          {/*        </p>*/}
          {/*        <ul className="icon_list unordered_list">*/}
          {/*          <li>*/}
          {/*            <span className="icon_list_text">*/}
          {/*              <strong className="text-dark">Industry:</strong> {project.Industry}*/}
          {/*            </span>*/}
          {/*          </li>*/}
          {/*          <li>*/}
          {/*            <span className="icon_list_text">*/}
          {/*              <strong className="text-dark">Country:</strong> {project.Country}*/}
          {/*            </span>*/}
          {/*          </li>*/}
          {/*        </ul>*/}
          {/*        <ul className="case_technologies unordered_list" data-text="Core Technologies:">*/}
          {/*          <li>*/}
          {/*            <img src={project.Technologies1} alt="Angular" />*/}
          {/*          </li>*/}
          {/*          <li>*/}
          {/*            <img src={project.Technologies2} alt="Elephent" />*/}
          {/*          </li>*/}
          {/*        </ul>*/}
          {/*        <Link onClick={ClickHandler} to={`/portfolio_details/${project.slug}`} className="btn btn-primary">*/}
          {/*          <span className="btn_label" data-text="Read Case">Read Case</span>*/}
          {/*          <span className="btn_icon">*/}
          {/*            <i className="fa-solid fa-arrow-up-right"></i>*/}
          {/*          </span>*/}
          {/*        </Link>*/}
          {/*      </div>*/}
          {/*    </div>*/}
          {/*  ))}*/}
          {/*</div>*/}

          {/*<div className="btns_group pb-0">*/}
          {/*  <Link onClick={ClickHandler} to="/portfolio" className="btn btn-primary">*/}
          {/*    <span className="btn_label" data-text="View More Cases Study">View More Cases Study</span>*/}
          {/*    <span className="btn_icon">*/}
          {/*      <i className="fa-solid fa-arrow-up-right"></i>*/}
          {/*    </span>*/}
          {/*  </Link>*/}
          {/*</div>*/}
        {/*</div>*/}
      </div>
      {/*<div className="decoration_item shape_image_1">*/}
      {/*  <img src={shape1} alt="Techco Shape" />*/}
      {/*</div>*/}
    </section>
  )
}

export default Start;